/**
 * Centralized regular expression validation patterns.
 */
export const REGEX = {
  /** Email format validation */
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  /** Standard HTTP / HTTPS URL format */
  URL: /^https?:\/\/[^\s$.?#].[^\s]*$/i,
  /** Alphanumeric strings */
  ALPHANUMERIC: /^[a-zA-Z0-9]+$/,
  /** Alphanumeric with spaces, underscores, and dashes */
  SEARCH_QUERY: /^[a-zA-Z0-9\s_\-.,!?()]+$/,
  /** Numeric digits only */
  DIGITS_ONLY: /^\d+$/,
  /** Semantic versioning (e.g. 1.0.0) */
  SEMVER:
    /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/,
  /** Leading URL scheme (e.g. "https:", "javascript:"), captured for an allow-list check */
  URL_SCHEME: /^([a-zA-Z][a-zA-Z0-9+.-]*):/,
  /** Whitespace (incl. tab/newline), which browsers silently strip from a URL before parsing its scheme */
  URL_WHITESPACE: /\s+/g,
} as const;
